export const getAccessToken = () => {
  try {
    return `Bearer ${
      JSON.parse(localStorage.getItem('okta-token-storage')).accessToken
        .accessToken
    }`;
  } catch (e) {
    console.info('Not authenticated');
    document.location.reload();
  }
  return '';
};

export const getActiveUserId = () =>
  localStorage.getItem('active-user-id') || null;

export default {};
